import { useQuery } from "@tanstack/react-query";
import { getBanks } from "@/services/bank.service";
import { Bank } from "@/models/bank.model";

interface UseBanksOptions {
  enabled?: boolean;
  page?: number;
  pageSize?: number;
}

export function useBanks({ enabled = true, page = 1, pageSize = 100 }: UseBanksOptions = {}) {
  return useQuery({
    queryKey: ["banks", page, pageSize],
    queryFn: async () => {
      const response = await getBanks(page, pageSize);
      return response.data as Bank[];
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutos - dados de bancos não mudam com frequência
    gcTime: 1000 * 60 * 10, // 10 minutos (anteriormente era cacheTime)
    retry: 2, // Tentar novamente 2 vezes em caso de erro
  });
}

